import "./OperationalAudit.module.css";
import Header from "@/reusable_sections/Header";
import AuditIntroduction from "./sections/AuditIntroduction";
import OperationalAuditForm from "./sections/OperationalAuditForm";
import Footer from "@/reusable_sections/Footer";
export default function OperationalAuditPage() {
  return <div>
      <Header />
      <AuditIntroduction />
      <OperationalAuditForm />
      <Footer />
    </div>;
}